import { render, staticRenderFns } from "./secondLevel.vue?vue&type=template&id=4d999c1b&scoped=true"
import script from "./secondLevel.vue?vue&type=script&lang=js"
export * from "./secondLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d999c1b",
  null
  
)

export default component.exports